import React, { Component } from 'react';
/* 개발담당:양유빈
 * 화면기능:서비스약관
 * 세부설명:
*/

export class Termsofservice extends Component {
    static displayName = Termsofservice.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    } 

    render() {
        return (
            <div className="container_box p_margin c_padding">

                <p className="text_type1">서비스 약관</p><br />
                <p className="text_type2">작성일: 2022년 4월 10일</p><br />
                <p className="text_type3">제1장 총칙</p><br />
                <p className="text_type4">제1조 (목적)</p><br />

                <p className="text_type5">본 약관은 주식회사 큰삼촌컴퍼니(이하 “회사”라 합니다)가 제공하는 서비스의 이용과 관련하여 회사와 회원 사이 권리와 의무를 규정하는 것을 목적으로 합니다.</p><br />

                <p className="text_type4">제2조 (용어의 정의)</p><br />

                <p className="text_type5">본 약관에서 이용하는 용어의 정의는 다음과 같습니다.<br />
                    1."서비스"란, 회사가 clo:D 브랜드를 이용하여 회원에게 제공하는 서비스로, clo:D 서비스와 기타 서비스가 있습니다.<br />
                    2."회원"이란 본 약관 제5조의 회원가입 절차를 통하여 정상적으로 회원가입을 한 자로, 계속적으로 회사가 제공하는 서비스를 이용할 수 있는 만14세 이상의 개인이나 법인을 의미합니다.<br />
                    3."소매처"란, 회원 중 회사가 제공하는 clo:D 서비스를 통해 상품 등을 구매하거나 화물 중계 서비스 및 간편 결제 및 정산 서비스를 신청할 수 있는 회원을 의미합니다.<br />
                    4."도매처"란, 회원 중 회사가 제공하는 clo:D 서비스를 통해 상품 등을 판매하거나 화물 중계 서비스 및 간편 결제 서비스를 신청할 수 있는 회원을 의미합니다.<br />
                    5."사입삼촌(사입업자)"이란, 회원 중 clo:D 서비스와 관련하여 도매처와 소매처 사이에서 중간 역할을 수행하는 회원을 의미합니다.<br />
                    6."clo:D 서비스"란, 회사가 회원에게 제공하는 서비스 중 도매처와 소매처 사이 상품의 판매 및 구매와 관련한 서비스로 구체적인 내용은 본 약관 제8조 제1항 가목에서 정합니다.<br />
                    7.본 조 제1항에 정의되지 않은 본 약관 상의 용어의 정의는 상법 등 관련법령과 일반적인 상거래 관행에 따릅니다.</p><br />

                <p className="text_type4">제3조 (약관의 명시, 효력 및 변경)</p><br />

                <p className="text_type5">1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 회사가 제공하는 서비스 화면에 게시하거나 기타의 방법으로 공지합니다. 본 약관은 본 약관에 동의한 회원 모두에게 그 효력이 발생합니다.<br />
                    2. 회사는 필요한 경우 약관의 규제에 관한 법률 등 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다.회사가 본 약관을 변경하는 경우, 변경약관 시행일 15일 전부터 회원에게 변경 사항을 서비스 화면 내에서 공지 또는 통지하는 것을 원칙으로 하며, 변경 사항이 회원에게 불리한 내용일 경우에는 변경약관 시행일 30일 전부터 회원에게 서비스 화면 내에서 공지 또는 통지하거나, 회원 가입 시 등록된 이메일 주소로 이메일을 발송하거나, 카카오톡 플러스친구를 통해 카카오톡 메시지를 보내거나, 서비스 내 푸시 메시지 전송하는 등 합리적으로 가능한 방법으로 공지 또는 통지합니다.<br />
                    3. 회사는 본조 제2항에 따라 회원에게 공지 또는 통지를 하면서 공지 또는 통지일로부터 변경약관 시행일 7일 후까지 거부 의사를 표시하지 아니하면 변경약관에 동의한 것으로 본다는 뜻을 명확하게 고지합니다. 이러한 고지에도 불구하고, 회원이 명시적으로 거부의 의사표시를 하지 않은 경우에는 변경된 약관에 동의한 것으로 봅니다. 회원이 변경약관에 동의하지 않을 경우 회원은 본 약관 제10조 제1항에 따라 이용 계약 해지 및 탈퇴를 할 수 있습니다.<br />
                </p><br />
                <p className="text_type4">제5조 clo:D 계정</p><br />

                <p className="text_type5">1. clo:D 계정이란 회원이 서비스를 이용하기 위해 필요한 로그인 계정을 의미합니다. clo:D 계정은 회원이 본 약관에 동의하고, clo:D 계정 생성을 위해 필요한 일정 정보를 입력하는 것으로 이용신청을 하면, 회사가 입력된 일정 정보를 인증한 후 가입을 승낙하는 절차로 생성됩니다.<br />
                    2. ‘아이디 (ID)’란 회원의 식별과 서비스의 이용을 위해 회원이 설정하고, 회사가 승인하여 등록된 본인명의의 핸드폰 번호를 의미합니다.<br />
                    3. ‘비밀번호’란 회원의 동일성 확인과 회원의 권익 및 비밀보호를 위해 회원 스스로가 설정해 회사에 등록한 영문, 숫자, 특수기호 등의 조합을 의미합니다.<br />
                    4. 소매처와 도매처는 각 계정 생성 후 1주 이내에 계정 활성화를 위해 패션 도·소매 관련업종의 상행위를 목적으로 상품을 판매·구매하는 것이라는 점을 증명하는 방법으로 회사에 사업자등록증 등 사업자임을 증명할 수 있는 자료를 반드시 제출해야 합니다.<br />
                    5. 사입삼촌(사입업자)은 회원 가입 신청 이후 회사가 정하는 절차에 따라 가입을 승낙받은 이후 서비스를 사용하실 수 있습니다.</p><br />

                <p className="text_type4">제6조 (clo:D 계정 활성화 거절 및 유보)</p><br />

                <p className="text_type5">1. 회사는 다음 각 호의 경우에는 회원의 clo:D 계정 활성화를 거절 및 유보할 수 있습니다.<br />
                    2. 회사가 본 약관에 의해 회원의 clo:D 계정을 삭제했던 경우<br />
                    3. 회원이 다른 사람의 명의나 이메일 주소 등 개인 정보를 이용하여 clo:D 계정을 생성한 경우<br />
                    4. 회원이 타인의 사업자 정보(사업자등록증 포함)를 이용하여 clo:D 계정을 생성한 경우<br />
                    5. 회원이 clo:D 계정 생성 시, 필요한 정보를 입력하지 않거나 허위의 정보를 입력하거나 제공한 경우<br />
                    6. 기타 회원이 본 약관, 회사가 정한 기준 기타 관련법령에 위배되는 행위를 하는 등 계정 활성화를 거절·유보하는 것이 필요하다고 합리적으로 판단되는 경우<br />
                    7. 만약, 회원이 본조 제1항의 조건에 위반해 clo:D 계정을 생성 및 활성화된 것이 판명된 때에는 회사는 즉시 회원의 서비스 이용을 중단하거나 clo:D계정을 삭제하는 등 적절한 제한을 할 수 있습니다.<br />
                    8. 회원에 대한 회사의 계정 활성화 의사 표시가 도달한 시점에 회원과 회사 간의 서비스 이용 계약이 성립합니다.</p><br />

                <p className="text_type4">제7조 ( clo:D 계정 관리)</p><br />

                <p className="text_type5">
                    1. clo:D 계정은 회원 본인만 이용할 수 있으며, 회사는 타인이 회원의 clo:D 계정을 이용하는 것을 허락하지 않습니다. 그리고 회원은 타인이 회원의 clo:D 계정을 무단으로 이용할 수 없도록 직접 아이디와 비밀번호를 관리하여야 합니다. 회사는 타인이 회원의 clo:D 계정을 무단으로 이용하는 것을 막기 위해 회원에게 비밀번호 입력 및 추가적인 본인 확인 절차를 거치도록 할 수 있습니다. 만약, 회원께서 타인의 clo:D 계정 무단 이용을 발견하신다면, clo:D 고객 센터를 통해 회사에게 알려주시기 바라며, 회사는 무단 이용을 막기 위한 방법을 회원에게 안내하도록 하겠습니다.<br />
                    2. 회원은 서비스 내에서 자신의 정보를 열람하고 수정할 수 있습니다. 다만, 서비스의 제공 및 관리를 위해 필요한 아이디, 환불 계좌 정보 등 일부 정보는 수정이 불가능할 수 있으며, 부득이하게 상기 정보의 수정을 원하시는 경우에는 추가적인 본인 확인 절차가 필요할 수 있습니다. 회원은 서비스 이용 신청 시 입력한 내용에 변동이 있을 때, 직접 서비스에서 수정하거나 고객 센터를 통하여 회사에 알려 주시기 바랍니다.<br />
                    3. 회사는 회원이 서비스를 통하지 않은 다른 방법으로 회원 정보를 수정하거나, 서비스 내 정보를 수정하지 않아 발생하는 손해에 대해 책임을 부담하지 아니합니다.</p><br />

                <p className="text_type3">제2장 서비스의 이용</p><br />


                <p className="text_type4">제8조 (다양한 서비스 제공 및 한계)</p><br />

                <p className="text_type5">회사는 다음과 같은 서비스를 제공합니다.<br />
                    1. clo:D서비스<br />
                    &nbsp; &nbsp;- 전자 상거래 플랫폼 개발 및 운영 서비스<br />
                    &nbsp; &nbsp;- 판매 및 구매 관련 지원 서비스<br />
                    &nbsp; &nbsp;- 구매 계약 체결 관련 서비스<br />
                    &nbsp; &nbsp;- 재화 또는 용역에 대한 정보 제공 및 배송에 대한 서비스<br />
                    &nbsp; &nbsp;- 광고 집행 및 프로모션 서비스<br />
                    &nbsp; &nbsp;- 기타 전자 상거래 관련 서비스<br />
                    2. 화물 연계 서비스<br />
                    3. 금융 연계 서비스<br />
                    4. 회사가 직접 또는 제휴사와 공동으로 제공하는 마케팅 등 기타 서비스<br />
                    5. 회사가 제공하는 본 조 제1항의 서비스는 회사가 회원이 상품 등을 거래할 수 있도록 서비스의 이용을 허락하는 경우에 한하며, 회사는 개별 도매처가 판매하는 상품 등에 관련해서는 일체의 책임을 지지 않습니다.<br />
                    6. 회사가 상품의 품절 또는 상품 사양의 변경 등을 확인한 경우에는 회사가 직접 상품 등의 관련 정보를 변경할 수 있습니다.<br />
                    7. 회사의 서비스는 소매처와 도매처가 상행위를 목적으로 하는 경우에만 제공되므로, 전자상거래 등에서의 소비자 보호에 관한 법률은 제3조 제1항에 의해 본 약관에 적용되지 않습니다. 회사는 상행위를 목적으로 하는 소매처와 도매처에 대한 적절한 서비스 제공을 위해 사업자등록증을 확인하는 등 기타의 방법으로 소매처와 도매처가 상행위를 목적으로 구매하는 것인지 여부를 언제든지 중복하여 확인할 수 있습니다. 또한 사입삼촌(사입업자)이 상행위를 목적으로 하는 소매처와 도매처의 업무를 위탁받아 제공하는 것인지 여부를 언제든지 중복하여 확인할 수 있습니다.<br />
                    8. 회사는 회원이 서비스를 마음껏 이용할 수 있도록 이에 필요한 소프트웨어를 제공합니다. 단, 회사가 회원에게 회사의 상표 및 로고를 이용할 권리를 부여하는 것은 아닙니다.<br />
                    9. 회사는 더 나은 서비스를 위해 서비스에 필요한 소프트웨어의 업데이트 버전을 제공할 수 있습니다. 소프트웨어의 업데이트에는 중요한 기능의 추가 또는 불필요한 기능의 제거 등이 포함되어 있습니다. 회원은 용이한 서비스 이용을 위해 꾸준히 업데이트를 해주시기 바랍니다.<br />
                    10. 회사는 더 나은 서비스의 제공을 위해 회원에게 서비스의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한 정보를 서비스에 표시하거나 회원의 이메일 계정으로 이메일을 직접 발송할 수 있습니다.<br />
                    11. 서비스 이용 중 시스템 오류 등 문제점을 발견하신다면 언제든지 clo:D 고객 센터로 알려주시기 바랍니다.<br />
                    12. 회원이 서비스를 이용하는 과정에서 Wi-Fi 무선 인터넷을 이용하지 않고, 가입하신 이동통신사의 무선 인터넷에 연결하여 이용하는 경우 이동통신사로부터 회원에게 별도의 데이터 통신 요금이 부과되는 점을 유의하여 주시기 바랍니다. 서비스 이용 과정에서 발생하는 데이터 통신 요금은 회원이 회원의 비용과 책임 하에 이동통신사에 납부하셔야 합니다. 데이터 통신 요금에 대한 자세한 안내는 회원이 가입한 이동통신사에 문의하시기 바랍니다.</p><br />

                <p className="text_type4">제9조 (서비스 기간 및 중단)</p><br />

                <p className="text_type5">1. 본 약관에 따른 서비스의 이용 기간은 clo:D 계정 활성화 시점부터 회원의 탈퇴 또는 자격 상실로 인해 이용 계약이 종료되는 시점까지입니다.<br />
                    2. 회사는 서비스를 제공하기 위한 정보 통신 설비의 보수, 점검, 교체 또는 고장, 통신의 두절 등의 사유가 발생한 경우에 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 서비스의 중단 사실 및 그 사유를 회원에게 알려 드립니다.<br />
                    3. 회사는 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우에 서비스의 제공을 제한하거나 일시 중단할 수 있습니다. 이 경우 회사는 서비스의 중단 사실 및 그 사유를 회원에게 알려 드립니다.<br />
                    4. 회사는 본 조 제2항 또는 제3항의 사유에 의한 서비스 중단에 대해 회사의 고의 또는 과실이 없는 경우, 회원의 손해를 배상하지 않습니다.</p><br />

                <p className="text_type4">제10조 (서비스 이용 계약의 종료)</p><br />

                <p className="text_type5">1. 회원은 언제든지 회사의 고객 센터를 통해 서비스 이용 계약의 해지 즉, 탈퇴를 요청할 수 있으며, 회사는 즉시 회원의 탈퇴를 처리합니다. 다만, 소매처와 도매처는 이용 계약의 해지를 위해 해지 요청일 최소 3일 전까지 존속 중인 구매 신청 및 대금 결제 등 확정된 구매 계약 거래를 완결시키는데 필요한 조치를 취해야 하며, 계약의 해지 절차를 이행해야 합니다. 만약 소매처와 도매처가 상기 필요한 조치를 취하지 않는 경우 그로 인해 발생하는 손해에 대해서는 회사가 책임지지 않습니다.<br />
                    2. 회원이 발한 서비스 이용 계약 해지 요청으로 인해 발생한 불이익에 대한 책임은 회원 본인이 부담하여야 하며, 회사는 이용 계약이 종료되면, 회사는 회원에게 부가적으로 제공한 각종 혜택을 회수할 수 있습니다.<br />
                    3. 회사는 회원이 다음 각 호의 사유에 해당하는 경우, clo:D계정을 제한 또는 정지시킬 수 있습니다.<br />
                    &nbsp; &nbsp;⑴ clo:D계정 생성 시, 허위의 내용을 기재한 경우<br />
                    &nbsp; &nbsp;⑵ 서비스를 통해 거래된 상품 등의 대금, 기타 서비스 이용과 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우<br />
                    &nbsp; &nbsp;⑶ 타인의 서비스 이용을 방해하거나, 그 정보를 도용하는 등 타인의 권리나 명예, 신용 등 기타 정당한 이익을 침해하는 행위를 한 경우<br />
                    &nbsp; &nbsp;⑷ 서비스를 이용하여 본 약관 또는 관련법령이 금지하거나 공서양속에 반하는 행위를 한 경우<br />
                    &nbsp; &nbsp;⑸ 회사가 제공하는 서비스의 원활한 진행을 방해하는 행위를 하거나 시도한 경우<br />
                    &nbsp; &nbsp;⑹ 회사가 제공하는 방법 이외의 다른 방법을 이용하여 서비스에 접근한 경우<br />
                    &nbsp; &nbsp;⑺ 회사의 동의 없이 서비스 또는 이에 포함된 소프트웨어의 일부를 복사, 수정, 배포, 판매, 양도, 대여, 담보 제공하거나 타인에게 그 이용을 허락하는 행위와 소프트웨어를 역설계하거나 소스 코드 추출을 시도하는 등 서비스를 복제, 분해 또는 모방하거나 기타 변형하는 행위를 한 경우<br />
                    &nbsp; &nbsp;⑻ 기타 회사가 합리적 판단에 기해 서비스 제공을 거부할 필요가 있다고 인정하는 경우<br />
                    4. 회사는 회사가 본 조 제3항에 따라 회원의 clo:D 계정 이용을 제한 또한 정지시킨 후, 14일 이내에 그 사유가 시정되지 아니하는 경우, 이용 계약을 해지할 수 있습니다.<br />
                    5. 회사는 회원의 동일한 행위로 인해 2회 이상 본 조 제3항에 따라 clo:D계정 이용을 제한 또는 정지시키는 경우, 이용 계약을 해지할 수 있습니다.<br />
                    6. 회사는 회사가 본 조 제3항 내지 제5항에 따라 회원의 clo:D 계정 이용을 제한 또는 정지하거나, 이용 계약을 해지하고자 하는 경우, 회원에게 이메일, 전화 기타의 방법을 통해 그 사유를 전달하고, 최대 30일의 기간을 정해 소명할 기회를 부여합니다.<br />
                    7. 회사는 회사가 본 조 제3항 내지 제5항에 따라 회원의 clo:D 계정 이용을 제한 또는 정지하거나, 이용 계약을 해지한 경우에는 회원에게 부가적으로 제공한 각종 혜택을 회수할 수 있습니다.<br />
                    8. 회사가 본 조 제3항 내지 제5항에 따라 회원의 clo:D 계정 이용을 제한 또는 정지하거나, 이용 계약을 해지한 경우라 하더라도, 그 이전에 이미 체결된 구매 계약의 완결과 관련해서는 본 약관이 적용됩니다.</p><br />

                <p className="text_type4">제11조 (회원에 대한 통지)</p><br />

                <p className="text_type5">1. 회사는 회원에 대해 통지하는 경우, 서비스 내에 게시하거나, 회원 가입 시 등록된 이메일 주소로 이메일을 발송하거나, 카카오톡 플러스친구를 통해 카카오톡 메시지를 보내거나, 서비스 내 푸시 메시지 전송 등 합리적으로 가능한 방법으로 통지합니다.<br />
                    2. 회사는 불특정 다수의 회원에 대해 통지하는 경우, 7일 이상 서비스 내에 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련해 중대한 영향을 미치는 사항에 대해서는 본 조 제1항에 따라 개별 통지를 합니다.<br />
                    3.본 약관에 따라 회사가 회원에게 통지를 함에 있어 회원이 연락 가능한 이메일 주소 등을 회사에 제공하지 않거나 이를 유효한 것으로 갱신하지 않음으로써 회사의 통지를 받지 못하는 경우 및 회원이 회사의 통지를 수신 거부하여 발생하는 회원의 손해에 대하여 회사는 일체의 책임을 부담하지 않습니다.</p><br />
                <p className="text_type3">제3장 clo:D 서비스</p><br />


                <p className="text_type4"> 제12조 (구매 신청)</p><br />

                <p className="text_type5">1. 소매처의 사입 업무를 위탁받은 사입삼촌(사입업자)이 서비스를 통해 청약의 의사표시(이하, ‘구매 신청’)를 함으로써, 소매처와 도매처의 상품 등에 대한 구매 계약이 체결됩니다.<br />
                    2. 소매처는 사입삼촌(사입업자)을 통하여 구매 신청을 함에 있어, 다음 각 호의 내용을 알기 쉽게 제공합니다.<br />
                    3. 도매처의 주소 및 전화번호 등 도매처 인식을 위한 내용<br />
                    4. 사입할 상품명, 가격, 수량 등 정확한 사입 물품의 정보<br />
                    5. 사입, 불량, 교환 등 사입내용에 대한 정보<br />
                    6. 기타 회사에서 제공되는 주문서 메뉴얼에 대한 정보 등</p><br />

                <p className="text_type4">제13조 (구매신청 철회 등)</p><br />
                <p className="text_type5"> 1. 회사가 제공하는 서비스의 특성상, 소매처가 상품 등을 주문하면 그 주문 내용이 사입삼촌(사입업자)에게 전달되고 사입삼촌(사입업자)이 구매신청을 하는 즉시 도매처에 전달되기 때문에 원칙적으로 구매신청 철회가 불가합니다.
                    2. 소매처의 단순 변심, 하자 의한 교환 또는 반품은 업무를 위탁한 사입삼촌(사입업자), 도매처와 협의해야 하며, 회사는 이에 관여하지 않을 뿐만 아니라 어떠한 책임도 지지 않습니다.</p><br />

                <p className="text_type3">제4장 기타 서비스</p><br />


                <p className="text_type4">제14조 (화물 연계 서비스 신청 등)</p><br />

                <p className="text_type5">1. 소매처 또는 도매처가 회사에 화물 연계 서비스를 신청하면, 회사는 소매처 또는 도매처에 회사와 제휴관계를 맺고 있는 운송업체를 알선해줍니다.<br />
                    2. 회사는 소매처 또는 도매처와 운송업체 사이에 발생한 문제, 사고에 관하여, 관여하지 않을 뿐만 아니라 어떠한 책임도 지지 않습니다.</p><br />

                <p className="text_type3">제5장 개인정보의 보호</p><br />


                <p className="text_type4">제15조 (개인정보의 보호)</p><br />

                <p className="text_type5">1. 회사는 서비스의 원활한 제공을 위해 회원이 동의한 목적과 범위 내에서만 회원의 개인정보를 수집 및 이용합니다.<br />
                    2. 회사는 수집한 회원의 개인정보를 법령에 의하거나 회원이 별도로 동의하지 아니하는 한 제3자에게 제공하거나 새로운 목적으로 이용하지 않습니다.<br />
                    3. 회사가 본 조 제1항 또는 제2항의 동의를 받는 경우, 회사는 개인정보의 수집 및 이용 목적, 제3자에 대한 정보 제공과 관련된 내용 등을 미리 명시하여야 하고, 회원은 언제든지 동의를 철회할 수 있습니다.<br />
                    4. 회원은 언제든지 회사가 처리하는 본인의 정보에 대한 열람 및 오류 정정을 요구할 수 있고, 회사는 이에 대해 지체없이 필요한 조치를 취해야 합니다.<br />
                    5. 회사 또는 회사로부터 개인정보를 제공받은 제3자는 개인 정보의 수집 목적 또는 제공받은 목적을 달성한 때에는 즉시 개인정보를 파기해야 합니다.<br />
                    6. 회사는 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에 관한 회원의 동의 거절 시에 제한되는 서비스를 구체적으로 명시합니다.<br />
                    7. 회사가 회원의 개인정보를 위탁하는 경우에는 관련법령에서 정한 바에 따라 ‘개인정보 취급방침’을 수립하고, 개인정보보호 책임자를 지정하여, 이를 게시하고 운영합니다.</p><br />

                <p className="text_type3">제6장 기타</p><br />


                <p className="text_type4">제17조 (회사의 의무)</p><br />

                <p className="text_type5">1. 회사는 본 약관 및 관련법령에서 금지하거나 공서양속에 반하는 행위를 하지 않으며, 본 약관에서 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하는데 최선을 다합니다.<br />
                    2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보 보호를 위한 보안 시스템을 갖춥니다.<br />
                    3. 회사는 제3자가 작성한 게시물의 진실성에 대해 보증하지 않습니다. 다만, 회사가 상품 등의 표시에 대해 『표시·광고의 공정화에 관한 법률』 제3조 소정의 부당한 행위를 함으로써 회원이 손해를 입은 경우, 회사는 이를 배상합니다.</p><br />

                <p className="text_type4">제18조 (소매처와 도매처의 의무)</p><br />

                <p className="text_type5">1. 소매처와 도매처는 본 약관 및 회사가 서비스에서 고지하는 내용을 준수해야 하며, 약관 및 고지 내용을 위반하거나 이행하지 아니하여 소매처와 도매처에 발생하는 손실 및 손해에 대한 책임은 소매처와 도매처에 있습니다.<br />
                    2. 소매처와 도매처는 다음과 같은 행위를 해서는 안되며, 해당 행위로 인하여 발생하는 분쟁은 회사가 책임지지 않습니다. 또한 회사가 입는 피해에 대한 손해를 회사가 소매처와 도매처에 청구할 수 있습니다.<br />
                    3. 허위 내용의 등록<br />
                    4. 타인의 정보 도용<br />
                    5. 서비스에 게시된 정보의 임의적 변경<br />
                    6. 서비스에 게시된 정보 이외의 정보의 송신 또는 게시<br />
                    7. 회사 또는 제3자의 저작권 등 지식재산권에 대한 침해<br />
                    8. 회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br />
                    9. 외설 또는 폭력적인 메시지, 화상, 음성 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위<br />
                    10. 회사의 임직원에 대한 외설 또는 폭력적인 메시지 기타 공서양속에 반하는 행위<br />
                    11. 회사의 서면 동의 없이 본 약관 상의 권리와 의무를 제3자에게 양도하거나 처분하는 행위</p><br />

                <p className="text_type4">제19조 (사입삼촌(사입업자)의 의무)</p><br />

                <p className="text_type5">1. 사입삼촌(사입업자)은 본 약관 및 회사가 서비스에서 고지하는 내용을 준수해야 하며, 약관 및 고지 내용을 위반하거나 이행하지 아니하여 사입삼촌(사입업자)에게 발생하는 손실 및 손해에 대한 책임은 사입삼촌(사입업자)에게 있습니다.<br />
                    2. 사입삼촌(사입업자)은 다음과 같은 행위를 해서는 안되며, 해당 행위의 발생시 소매처, 도매처와 발생하는 분쟁은 회사가 책임지지 않습니다. 또한 회사가 입는 피해에 대한 손해를 회사가 사입삼촌(사입업자)에게 청구할 수 있습니다.<br />
                    3. 허위 내용의 등록<br />
                    4. 타인의 정보 도용<br />
                    5. 서비스에 게시된 정보의 임의적 변경<br />
                    6. 서비스에 게시된 정보 이외의 정보의 송신 또는 게시<br />
                    7. 회사 또는 제3자의 저작권 등 지식재산권에 대한 침해<br />
                    8. 회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br />
                    9. 외설 또는 폭력적인 메시지, 화상, 음성 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위<br />
                    10. 회사의 임직원에 대한 외설 또는 폭력적인 메시지 기타 공서양속에 반하는 행위<br />
                    11. 회사의 서면 동의 없이 본 약관 상의 권리와 의무를 제3자에게 양도하거나 처분하는 행위</p><br />

                <p className="text_type4">제20조 (제3자 서비스에 대한 면책)</p><br />

                <p className="text_type5">서비스에 게시된 하이퍼링크 (문자, 그림 등)를 통해 제3자의 서비스로 연결된 경우, 제3자의 서비스에서 회원이 행하는 거래에 대해서 회사는 어떠한 보증 책임도 지지 않습니다.</p><br />

                <p className="text_type4">제21조 (저작권의 귀속 및 이용 제한)</p><br />
                <p className="text_type5">1. 회사가 서비스 내에 게시한 저작물에 대한 저작권 기타 지식재산권은 회사에 귀속됩니다.<br />
                    2. 회원이 서비스를 이용하는 과정에서 획득한 정보 중 회사에게 저작권 기타 지식재산권이 귀속된 정보를 회사의 사전 서면 승낙없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의해 영리 목적으로 이용하거나 제3자에게 이용하게 해서는 안됩니다.</p><br />

                <p className="text_type4">제22조 (보증의 부인)</p><br />

                <p className="text_type5">1. 회사는 서비스를 통한 소매처, 사입삼촌(사입업자), 도매처 간의 거래와 관련해 등록 상품 등의 품질, 완전성, 안전성, 적법성 및 타인의 권리에 대한 비침해성, 소매처와 사입삼촌(사입업자)가 입력한 정보 및 그 정보를 통해 연결된 정보의 진실성 또는 적법성 등 일체에 대해 보증하지 아니하며, 이와 관련한 일체의 위험과 책임은 해당 회원이 부담합니다.<br />
                    2. 회사는 회원의 상품 주문과 관련해 다음 각 호의 내용 일체에 대해 보증하지 아니하며, 이와 관련한 일체의 위험과 책임은 회원이 부담합니다. 또한 회사는 법률상 허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해 및 징벌적 손해에 대한 책임을 부담하지 않습니다.<br />
                    3. 소매처가 입력한 주문 상품 정보 미기재 또는 오기재로 등으로 인한 사입삼촌(사입업자)의 사입 및 배송 불가<br />
                    4. 소매처, 사입삼촌(사입업자), 도매처 사이에 사전에 협의되지 않은 주문 상품의 교환 또는 반품<br />
                    5. 소매처, 사입삼촌(사입업자), 도매처 간의 매입금 현황 및 매입금 관련 분쟁 일체<br />
                    6. 소매처, 사입삼촌(사입업자)이 합의되지 않았을 때 발생하는 정산, 배송, 교환 또는 반품 등 관련 문제 일체<br />
                    7. 기타 소매처, 사입삼촌(사입업자), 도매처 간에 발생하거나 발생할 가능성이 있는 분쟁 사항 일체</p><br />

                <p className="text_type4">제23조 (이용 계약 구성 및 일부 무효)</p><br />

                <p className="text_type5">1. 본 약관과 관련해 당사자 간의 합의에 의해 추가로 작성된 계약서, 협정서, 통보서 등과 회사의 정책 변경, 관련법령의 제·개정 또는 공공 기관의 고시나 지침 등에 의해 회사가 서비스를 통해 공지하는 내용도 이용 약관의 일부를 구성합니다.<br />
                    2. 관련법령 등에 의해 본 약관의 일부 규정이 무효가 될 경우, 나머지 규정만으로 그 목적 달성이 불가능하거나 회원에게 부당하게 불리하지 아니하는 이상 본 약관은 그 효력을 유지합니다.</p><br />

                <p className="text_type4">제24조 (분쟁 해결 및 관할)</p><br />

                <p className="text_type5">1. 회사는 회원이 제기하는 정당한 의견이나 불만을 반영하고, 그 피해를 보상하기 위해 필요시에 피해 보상 처리 기구를 설치·운영합니다.<br />

                    2. 회사는 회원으로부터 제출된 불만 사항 및 의견을 우선적으로 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리 일정을 즉시 통보합니다.<br />
                    3. 본 약관과 관련해 회사와 회원 간에 발생한 모든 국내 분쟁은 『전자문서 및 전자거래 기본법』 제32조에 의해 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.<br />
                    4. 본 약관과 관련해 회사와 회원 간에 발생한 국제 거래 분쟁은 대한민국 서울에서, 대한상사중재원에서 국제중재규칙과 대한민국 법에 따라 해결할 수 있습니다. 중재판정부는 당사자들의 합의에 따라 1인으로 구성합니다.</p><br />

                <p className="text_type4">제25조 (재판권 및 준거법)</p><br />

                <p className="text_type5">1. 본 약관과 이용 계약 및 회원 상호간의 분쟁에 대해 회사를 당사자로 하는 소송이 제기될 경우에는 서울중앙지방법원을 합의 관할 법원으로 정합니다.<br />
                    2. 본 조 제1항의 분쟁으로 제기된 소송에는 대한민국 법령을 적용합니다.</p><br />

                <p className="text_type4">부칙</p><br />

                <p className="text_type5">본 약관은 2022년 4월 10일부터 적용됩니다.</p>
            </div>
        );
    }
}
